import { Component } from '@angular/core';

@Component({
  selector: 'howden-file-library-insurance',
  templateUrl: './file-library-insurance.component.html',
  styleUrls: ['./file-library-insurance.component.scss']
})
export class FileLibraryInsuranceComponent {
}
